import { render, staticRenderFns } from "./cusBtn3.vue?vue&type=template&id=656b91be&scoped=true"
import script from "./cusBtn3.vue?vue&type=script&lang=js"
export * from "./cusBtn3.vue?vue&type=script&lang=js"
import style0 from "./cusBtn3.vue?vue&type=style&index=0&id=656b91be&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656b91be",
  null
  
)

export default component.exports